var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEmailiconwhite(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 13,
    viewBox: "0 0 18 13",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.3125 2.5625V10.4375C16.3125 10.8851 16.1347 11.3143 15.8182 11.6307C15.5018 11.9472 15.0726 12.125 14.625 12.125H3.375C2.92745 12.125 2.49822 11.9472 2.18176 11.6307C1.86529 11.3143 1.6875 10.8851 1.6875 10.4375V2.5625M16.3125 2.5625C16.3125 2.11495 16.1347 1.68573 15.8182 1.36926C15.5018 1.05279 15.0726 0.875 14.625 0.875H3.375C2.92745 0.875 2.49822 1.05279 2.18176 1.36926C1.86529 1.68573 1.6875 2.11495 1.6875 2.5625M16.3125 2.5625V2.74475C16.3125 3.03286 16.2388 3.31618 16.0983 3.56772C15.9578 3.81926 15.7553 4.03065 15.51 4.18175L9.885 7.643C9.61891 7.8069 9.31252 7.89369 9 7.89369C8.68748 7.89369 8.38109 7.8069 8.115 7.643L2.49 4.1825C2.24469 4.0314 2.04215 3.82001 1.90168 3.56847C1.7612 3.31693 1.68747 3.03361 1.6875 2.7455V2.5625",
    stroke: "#8E8E93",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmailiconwhite);
export default __webpack_public_path__ + "static/media/Emailiconwhite.4493aec1d0237434b0f602999f7317fd.svg";
export { ForwardRef as ReactComponent };